import { ActionType } from '../constants/ActionTypes';
import { RestPath } from '../constants/SitePaths';
import config from '../constants/Configs';
import axios from 'axios';
import { Constants } from '../constants/Constants';
import { message } from "antd";

// Add new affiliate
export const addNewAffiliateBegin = () => ({
    type: ActionType.ADD_NEW_AFFILIATE_BEGIN
});

export const addNewAffiliateSuccess = affiliate => ({
    type: ActionType.ADD_NEW_AFFILIATE_SUCCESS,
    payload: { affiliate }
});

export const addNewAffiliateError = (error) => ({
    type: ActionType.ADD_NEW_AFFILIATE_FAILURE,
    payload: { error }
});

//Get Affiliates
export const getAffiliateBegin = () => ({
    type: ActionType.GET_AFFILIATE_BEGIN,
});

export const getAffiliateSuccess = (data) => ({
    type: ActionType.GET_AFFILIATE_SUCCESS,
    payload: data
});

export const getAffiliateError = (data) => ({
    type: ActionType.GET_AFFILIATE_FAILURE,
    payload: data
});

//Get Project id
export const getProjectIdBegin = () => ({
    type: ActionType.GET_PROJECT_ID_BEGIN,
});

export const getProjectIdSuccess = (data) => ({
    type: ActionType.GET_PROJECT_ID_SUCCESS,
    payload: data
});

export const getProjectIdError = (data) => ({
    type: ActionType.GET_PROJECT_ID_FAILURE,
    payload: data
});

//Get Affiliates Info
export const getAffiliateInfoBegin = () => ({
    type: ActionType.GET_AFFILIATE_INFO_BEGIN,
});

export const getAffiliateInfoSuccess = (data) => ({
    type: ActionType.GET_AFFILIATE_INFO_SUCCESS,
    payload: data
});

export const getAffiliateInfoError = (data) => ({
    type: ActionType.GET_AFFILIATE_INFO_FAILURE,
    payload: data
});

// Change Affiliate status
export const changeStatusAffiliateBegin = () => ({
    type: ActionType.CHANGE_STATUS_BEGIN
});

export const changeStatusAffiliateSuccess = (data) => ({
    type: ActionType.CHANGE_STATUS_SUCCESS,
    payload: data
});

export const changeStatusAffiliateError = (data) => ({
    type: ActionType.CHANGE_STATUS_FAILURE,
    payload: data
});

// Get Permissions
export const getPermissionsBegin = () => ({
    type: ActionType.GET_PERMISSIONS_BEGIN
});

export const getPermissionsKeepOldBegin = () => ({
    type: ActionType.GET_PERMISSIONS_KEEP_OLD_BEGIN
});

export const getPermissionsSuccess = (data) => ({
    type: ActionType.GET_PERMISSIONS_SUCCESS,
    payload: data
});

export const getPermissionsError = (data) => ({
    type: ActionType.GET_PERMISSIONS_FAILURE,
    payload: data
});

// Update Permissions
export const updatePermissionsBegin = () => ({
    type: ActionType.UPDATE_PERMISSIONS_BEGIN
});

export const updatePermissionsSuccess = permissions => ({
    type: ActionType.UPDATE_PERMISSIONS_SUCCESS,
    payload: { permissions }
});

export const updatePermissionsError = (error) => ({
    type: ActionType.UPDATE_PERMISSIONS_FAILURE,
    payload: { error }
});

// Get Commissions
export const getCommissionsBegin = () => ({
    type: ActionType.GET_COMMISSIONS_BEGIN
});

export const getCommissionsSuccess = (data) => ({
    type: ActionType.GET_COMMISSIONS_SUCCESS,
    payload: data
});

export const getCommissionsError = (data) => ({
    type: ActionType.GET_COMMISSIONS_FAILURE,
    payload: data
});

// Update Commissions
export const updateCommissionsBegin = () => ({
    type: ActionType.UPDATE_COMMISSIONS_BEGIN
});

export const updateCommissionsSuccess = commissions => ({
    type: ActionType.UPDATE_COMMISSIONS_SUCCESS,
    payload: { commissions }
});

export const updateCommissionsError = (error) => ({
    type: ActionType.UPDATE_COMMISSIONS_FAILURE,
    payload: { error }
});

// Get User Allowed Affiliates
export const getUserAllowedAffiliatesBegin = () => ({
    type: ActionType.GET_USER_ALLOWED_AFFILIATES_BEGIN
});

export const getUserAllowedAffiliatesSuccess = (data) => ({
    type: ActionType.GET_USER_ALLOWED_AFFILIATES_SUCCESS,
    payload: data
});

export const getUserAllowedAffiliatesError = (data) => ({
    type: ActionType.GET_USER_ALLOWED_AFFILIATES_FAILURE,
    payload: data
});

// Save open tree value
export const saveOpenTreeValue = (data) => ({
    type: ActionType.SAVE_OPEN_TREE_VALUE,
    payload: data
});

export const setSelectedTreeValueBegin = (data) => ({
    type: ActionType.SET_SELECTED_TREE_VALUE,
    payload: data
});

export function setSelectedTreeValue(data) {

    return dispatch => {
        dispatch(setSelectedTreeValueBegin(data));

    };
};

/* Add New affiliate */
export function addNewAffiliate(data, intl) {

    return dispatch => {
        dispatch(addNewAffiliateBegin());

        const params = {
            ...data
        };

        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.CREATE_AFFILIATE,
            data: JSON.stringify(params),

        }).then((response) => {
            // Success
            dispatch(addNewAffiliateSuccess(response.data));
            message.success(intl.messages.success_affiliate);
            return data;
        })
            .catch((error) => {
                dispatch(addNewAffiliateError(error));
                return ("error")
            });
    };
}

// Get affiliates
export function getAffiliates(mainPartnerId, pageNumber) {
    return dispatch => {
        dispatch(getAffiliateBegin());

        let params = {
            pageNumber,
            mainPartnerId
        };

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_AFFILIATES,
            params: params

        }).then((response) => {
            dispatch(getAffiliateSuccess(response.data));
            return response.data;
        })
            .catch((error) => {
                dispatch(getAffiliateError(error));
            });
    }
}

// Get affiliates
export function getProjectId(affiliateId) {
    return dispatch => {
        dispatch(getProjectIdBegin());

        let params = {
            id: affiliateId
        };
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_PROJECT_ID,
            params: params

        }).then((response) => {
            dispatch(getProjectIdSuccess(response.data));
            return response.data;
        })
            .catch((error) => {
                dispatch(getProjectIdError(error));
            });
    }
}

// Get affiliates Info (for user page)
export function getAffiliatesInfo(mainPartnerId) {
    return dispatch => {
        dispatch(getAffiliateInfoBegin());

        const params = `?partnerId=${mainPartnerId}`;

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_AFFILIATES_INFO + params,

        }).then((response) => {
            dispatch(getAffiliateInfoSuccess(response.data));
            return response.data;
        })
            .catch((error) => {
                dispatch(getAffiliateInfoError(error));
            });
    }
}

//Change Affiliate status
export function changeStatusAffiliate(changeStatusData, intl) {
    return dispatch => {
        dispatch(changeStatusAffiliateBegin());

        const params = {
            ...changeStatusData
        };

        return axios({
            method: Constants.PUT,
            url: config.BASE_URL + RestPath.CHANGE_AFFILIATE_STATUS,
            data: params

        }).then((response) => {
            dispatch(changeStatusAffiliateSuccess(response.data));
            message.success(intl.messages.status_changed);
            return response.data;
        })
            .catch((error) => {
                dispatch(changeStatusAffiliateError(error));
            });
    }
}

//Get Affiliate permissions
export function getPermissions(id, keepOldData) {
    return dispatch => {
        keepOldData ? dispatch(getPermissionsKeepOldBegin()) : dispatch(getPermissionsBegin());

        const params = { id };

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_PERMISSIONS,
            params: params

        }).then((response) => {
            dispatch(getPermissionsSuccess(response.data));
            return response.data;
        })
            .catch((error) => {
                dispatch(getPermissionsError(error));
            });
    }
}

//Update Affiliate permissions
export function updatePermissions(data, intl) {
    return dispatch => {
        dispatch(updatePermissionsBegin());

        const params = data;

        return axios({
            method: Constants.PUT,
            url: config.BASE_URL + RestPath.UPDATE_PERMISSIONS,
            data: JSON.stringify(params),

        }).then((response) => {
            // Success
            dispatch(updatePermissionsSuccess(params));
            message.success(intl.messages.permissions_changed);

            return response.data;
        })
            .catch((error) => {
                dispatch(updatePermissionsError(error));
            });
    }
}

//Get Affiliate Commissions
export function getCommissions(id) {
    return dispatch => {
        dispatch(getCommissionsBegin());

        const params = { id };

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_COMMISSIONS,
            params: params

        }).then((response) => {
            dispatch(getCommissionsSuccess(response.data));
            return response.data;
        })
            .catch((error) => {
                dispatch(getCommissionsError(error));
            });
    }
}

//Update Affiliate Commissions
export function updateCommissions(data, intl) {
    return dispatch => {
        dispatch(updateCommissionsBegin());

        const params = data;

        return axios({
            method: Constants.PUT,
            url: config.BASE_URL + RestPath.UPDATE_COMMISSIONS,
            data: JSON.stringify(params),

        }).then((response) => {
            // Success
            dispatch(updateCommissionsSuccess(params));
            message.success(intl.messages.commissions_changed);

            return response.data;
        })
            .catch((error) => {
                dispatch(updateCommissionsError(error));
            });
    }
}

// Get User Allowed Affiliates (for tree)
export function getUserAllowedAffiliates(mainPartnerId) {
    return dispatch => {
        dispatch(getUserAllowedAffiliatesBegin());

        let params = {
            partnerId: mainPartnerId
        };

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_USER_ALLOWED_AFFILIATES,
            params: params

        }).then((response) => {
            dispatch(getUserAllowedAffiliatesSuccess({ data: response.data, parentId: mainPartnerId }));
            return response.data;
        })
            .catch((error) => {
                dispatch(getUserAllowedAffiliatesError(error));
            });
    }
}




// WEBPACK FOOTER //
// ./src/actions/AffiliateActions.js